import type { ScheduledDropResponse } from '~entities/scheduled-drops/api/get-scheduled-drops';

export const SCHEDULED_DROP_STATUS = {
  PENDING: 'pending',
  EXECUTED: 'executed',
  CANCELLED: 'cancelled',
} as const;

export const SCHEDULED_DROP_CREATED_BY = {
  STUDIO: 'studio',
  PARENT: 'parent',
} as const;

export interface ScheduledDropsTableProps {
  drops: Array<ScheduledDropResponse>;
  onCancel: (drop: ScheduledDropResponse) => void;
  onViewReason: (drop: ScheduledDropResponse) => void;
}
